var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C10.7574 12.75 9.75 13.7574 9.75 15C9.75 16.2426 10.7574 17.25 12 17.25C13.2426 17.25 14.25 16.2426 14.25 15C14.25 13.7574 13.2426 12.75 12 12.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85049 3.5623C10.4239 3.05623 11.1753 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H16.75V6C16.75 3.37665 14.6234 1.25 12 1.25C10.7959 1.25 9.69478 1.69904 8.85789 2.4377C8.54733 2.71179 8.51778 3.18575 8.79188 3.4963C9.06598 3.80685 9.53994 3.8364 9.85049 3.5623ZM8.25 15C8.25 12.9289 9.92893 11.25 12 11.25C14.0711 11.25 15.75 12.9289 15.75 15C15.75 17.0711 14.0711 18.75 12 18.75C9.92893 18.75 8.25 17.0711 8.25 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.4eceaeaca456e1184a299d6ef48b8dff.svg";
export { ForwardRef as ReactComponent };